import * as React from "react";

interface GameProps {
  title: string;
  artUrl: string;
  platform: string;
}

interface CurrentlyPlayingProps {
  games: any[];
  playing: any[];
}

const getGameProps = (playedGame: any, games: any): GameProps => {
  const g = games[playedGame.gameId];
  return {
    title: g.title,
    artUrl: g.artUrl,
    platform: playedGame.platform
  };
};
// games.find(game => game.gameId === gameId);

export const CurrentlyPlaying = ({ games, playing }: CurrentlyPlayingProps) => {
  const gameList = playing.map((playedGame: any) => (
    <Game
      key={playedGame.gameId}
      {...getGameProps(playedGame, games)}
      platform={playedGame.platform}
    />
  ));
  return (
    <div className="fb-column playing">
      <h2>Playing right now</h2>
      <div className="game-grid fb-row fb-wrap fb-jsb">{gameList}</div>
    </div>
  );
};

const Game = ({ artUrl, title, platform }: GameProps) => (
  <div className="fb-column game">
    <img className="game-art" src={artUrl} alt={title + " cover art"} />
    <div className="title-and-platform fb-column">
      <span>{title}</span>
      <span className="platform">{platform}</span>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/Profile/CurrentlyPlaying.tsx